/**
 * Service pour les localités
 */

import api from './api.js';

/**
 * Obtenir toutes les régions
 */
export async function getRegions() {
  const response = await api.get('/localites/regions');
  return response.data;
}

/**
 * Obtenir les départements d'une région
 */
export async function getDepartementsByRegion(regionId) {
  const response = await api.get(`/localites/regions/${regionId}/departements`);
  return response.data;
}

/**
 * Obtenir les communes d'un département
 */
export async function getCommunesByDepartement(departementId) {
  const response = await api.get(`/localites/departements/${departementId}/communes`);
  return response.data;
}

/**
 * Obtenir les quartiers d'une commune
 */
export async function getQuartiersByCommune(communeId) {
  const response = await api.get(`/localites/communes/${communeId}/quartiers`);
  return response.data;
}

/**
 * Obtenir une localité par ID
 */
export async function getLocaliteById(localiteId) {
  const response = await api.get(`/localites/${localiteId}`);
  return response.data;
}

/**
 * Rechercher des localités
 */
export async function searchLocalites(searchTerm, type = null) {
  const params = new URLSearchParams({ q: searchTerm });
  if (type) params.append('type', type);

  const response = await api.get(`/localites/search?${params.toString()}`);
  return response.data;
}

/**
 * Admin: Créer une localité
 */
export async function createLocalite(data) {
  const response = await api.post('/admin/localites', data);
  return response.data;
}

/**
 * Admin: Mettre à jour une localité
 */
export async function updateLocalite(id, data) {
  const response = await api.put(`/admin/localites/${id}`, data);
  return response.data;
}

/**
 * Admin: Supprimer une localité
 */
export async function deleteLocalite(id) {
  const response = await api.delete(`/admin/localites/${id}`);
  return response.data;
}

/**
 * Admin: Importer des localités depuis un fichier CSV
 */
export async function importLocalitesCsv(file) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/admin/localites/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}
